import { lazy } from 'react'

export const FinishingTouches = lazy(() => import('./v1/FinishingTouches'))
